import { render, staticRenderFns } from "./ProceduresForm.vue?vue&type=template&id=1030bb70&scoped=true"
import script from "./ProceduresForm.vue?vue&type=script&lang=js"
export * from "./ProceduresForm.vue?vue&type=script&lang=js"
import style0 from "./ProceduresForm.vue?vue&type=style&index=0&id=1030bb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1030bb70",
  null
  
)

export default component.exports